import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import EmployeeDashboard from "./EmployeeDashboard";
import DriverDashboard from "./DriverDashboard";
import AdminDashboard from "./AdminDashboard";

const RoleBasedRoute = () => {
  const { isAuthenticated, userDetails } = useSelector((state) => state.auth);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If user details are not loaded yet
  if (!userDetails) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white border border-gray-300 rounded-lg p-8 shadow-lg">
          <p className="text-gray-800 text-lg">Loading user dashboard...</p>
        </div>
      </div>
    );
  }

  // Route based on role
  const userRole = userDetails.role?.toLowerCase();

  switch (userRole) {
    case "driver":
      return <DriverDashboard />;
    case "admin":
      return <AdminDashboard />;
    case "employee":
    case "supervisor":
    case "engineer":
      return <EmployeeDashboard />;
    default:
      // Default to employee dashboard for unknown roles
      return <EmployeeDashboard />;
  }
};

export default RoleBasedRoute;
